import React from 'react'
const style={
        'lineHeight': '26px',
        'background': '#BBC0CB',
        'color': '#fff',
        'textAlign': 'center',
        'fontSize': 14,
        'padding':'20px 0'
}
export default class Bottom extends React.Component {
    render(){
        return(<div>
            <div className="bottom" style={style}>
                Copyright © 深圳市彩之云网络科技有限公司, All Rights Reserved.
            <br/>
网站备案号：粤ICP备13038151号     |     经营许可证号：粤B2-20130390
            </div>
        </div>)
    }
}



// WEBPACK FOOTER //
// ./src/api/bottom.jsx